import { Button, Modal } from 'antd';
import moment from 'moment-timezone';
import React from 'react';
import {
  DEFAULTDATETIMEFORMAT,
  REGISTER_LOG_STATUS,
} from '../../common/constants';

const RegisterApprovalPopUp = (props) => {
  const { showModal, setShowModal, data } = props;

  const handleOK = () => {
    setShowModal(false);
  };

  const registerDetail = data;
  const approverName = 'User'; // Can be enhanced later with actual approver data

  return (
    <Modal
      maskClosable={false}
      centered
      open={showModal}
      closable={false}
      footer={null}
    >
      <h3>Register Log already reviewed</h3>
      <div>
        <p className="font-size-16 mb-5">
          {`${approverName} has already done the review and given ${
            registerDetail && REGISTER_LOG_STATUS[registerDetail?.status]
          } on date ${
            registerDetail &&
            moment(registerDetail?.updatedAt)
              ?.tz(data?.register?.project?.timeZone)
              ?.format(DEFAULTDATETIMEFORMAT)
              ?.toUpperCase()
          }.`}
        </p>
      </div>
      <div className="form-buttons">
        <Button
          shape="round"
          type="primary"
          className="save-button"
          onClick={handleOK}
        >
          Okay
        </Button>
      </div>
    </Modal>
  );
};

export default RegisterApprovalPopUp;
